import React from 'react'
import NoteContext from './noteContext'
import { useState } from 'react'
import { useRef } from 'react'
import useLocalStorage from '../../components/useLocalStorage'
const NoteState = (props) => {
 const [backgroundColor, setBackgroundColor] = useState('white')
 const [bars, setBars] = useState('white-bars')
  const ref= useRef(null)
  const closeNavbar = ()=>{
    ref.current.click()
  }

  const [heading, setHeading] = useLocalStorage('heading',"")
return (
  <NoteContext.Provider value={{heading,setHeading,backgroundColor, setBackgroundColor,ref,closeNavbar,bars,setBars}}>
    {props.children}
  </NoteContext.Provider>
)
}

export default NoteState


// WEBPACK FOOTER //
// ./src/context/notes/noteState.jsx